export const SET_ITEMS = 'SET_ITEMS';
export const SET_WIDGET_INFO = 'SET_WIDGET_INFO';
export const SET_VEHICLE_INFO = 'SET_VEHICLE_INFO';
